import React from 'react';
import LineChart from './LineChart';
import BarChart from './BarChart';
import PieChart from './PieChart';
import './Charts.css';

const ApplicationAnalytics = ({ data = {} }) => {
  const {
    applicationSubmissions = [{ timestamp: new Date(), value: 0 }],
    applicationsByType = [
      { category: 'Nonprofit', count: 0, percentage: 0 },
      { category: 'Individual', count: 0, percentage: 0 },
      { category: 'Foundation', count: 0, percentage: 0 }
    ],
    completionRates = {
      started: 0,
      inProgress: 0,
      completed: 0,
      abandoned: 0
    },
    averageCompletionTime = '0m',
    commonDropoffPoints = []
  } = data;

  return (
    <div className="application-analytics">
      <h2>Application Analytics</h2>
      <div className="charts-grid">
        <div className="chart-container">
          <h3>Application Submissions Over Time</h3>
          <LineChart 
            data={applicationSubmissions}
            xAxis="Date"
            yAxis="Submissions"
          />
        </div>

        <div className="chart-container">
          <h3>Applications by Type</h3>
          <PieChart 
            data={applicationsByType.map(type => ({
              label: type.category,
              value: type.count,
              percentage: type.percentage
            }))}
          />
        </div>

        <div className="metrics-overview">
          <div className="metric-card">
            <h4>Completion Rate</h4>
            <p>{((completionRates.completed / 
              (completionRates.started || 1)) * 100).toFixed(1)}%</p>
          </div>
          <div className="metric-card">
            <h4>Avg. Completion Time</h4>
            <p>{averageCompletionTime}</p>
          </div>
          <div className="metric-card">
            <h4>Abandonment Rate</h4>
            <p>{((completionRates.abandoned / 
              (completionRates.started || 1)) * 100).toFixed(1)}%</p>
          </div>
        </div>

        <div className="dropoff-analysis">
          <h3>Common Dropoff Points</h3>
          <BarChart 
            data={commonDropoffPoints.map(point => ({
              x: point.step,
              y: point.count
            }))}
            xAxis="Application Step"
            yAxis="Dropoffs"
          />
        </div>
      </div>
    </div>
  );
};

export default ApplicationAnalytics; 